import Vue from 'vue'

export default {
    UPDATE_ACCOUNTS (state, value) {
        Vue.set(state, 'accounts', value);
    },
  SET_ACCOUNTS (state, value) {
        this.commit('UPDATE_ACCOUNTS', value);
    },
    SET_SELECTED_ACCOUNT (state,  value ) {
      Vue.set(state, 'selectedAccount', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/mutations.js